The response from the `updatePositionOpeningStatus` mutation.
